var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticClass:"rb-privacy",attrs:{"fluid":""}},[_c('b-row',[_c('b-col',{staticClass:"my-5",attrs:{"xl":"8","offset-xl":"2","lg":"10","offset-lg":"1"}},[_c('input',{ref:"fileInput",attrs:{"type":"file","accept":"video/*"},on:{"change":_vm.onFileInputChange}}),_vm._v("\\\n\n\t\t\t"),(_vm.videoUrl)?_c('rb-video-player',{attrs:{"sources":[{
					url: _vm.videoUrl,
					quality: {
						name: 'FHD',
						size: 1080
					}
				}]}}):_vm._e(),_c('canvas',{ref:"canvas",attrs:{"width":"1200","height":"400"}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }